import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { PrismButtonComponent } from '@shure/prism-angular-components';

import { StepRouter } from '../step-router';

@Component({
	selector: 'sh-step-router-footer-outlet',
	standalone: true,
	templateUrl: './step-router-footer-outlet.component.html',
	styleUrl: './step-router-footer-outlet.component.scss',
	imports: [CommonModule, PrismButtonComponent]
})
export class StepRouterFooterOutletComponent {
	constructor(protected readonly stepRouter: StepRouter) {}
}
